/* tslint:disable:max-line-length */

import { Injectable, NgZone } from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {  Observable } from 'rxjs';
import { EspecialService } from '../../../controllers/Especial';
import * as __model from '../../../model';
import { APIConfigService } from '../../../apiconfig.service';

import * as __utils from '../../../yasag-utils';

import { YASAGPostFormService } from '../../yasag-post.service';


@Injectable()
export class EspecialCreateFormService extends YASAGPostFormService<__model.Especial> {
  static xImiRoles = {"admin":"administrator can use this endpoint"};
  form = new FormGroup({
    data: new FormGroup({
      codi_especial: new FormControl({value: undefined, disabled: false}, [Validators.maxLength(512), Validators.minLength(1), Validators.required]),
      text_ca: new FormControl({value: undefined, disabled: false}, [Validators.minLength(1), Validators.required]),
      text_es: new FormControl({value: undefined, disabled: false}, [Validators.minLength(1), Validators.required]),
      text_en: new FormControl({value: undefined, disabled: false}, [Validators.minLength(1), Validators.required]),
      alt_ca: new FormControl({value: '', disabled: false}, [Validators.maxLength(512)]),
      alt_es: new FormControl({value: '', disabled: false}, [Validators.maxLength(512)]),
      alt_en: new FormControl({value: '', disabled: false}, [Validators.maxLength(512)]),
    }, [Validators.required]),
    fields: new FormControl({value: undefined, disabled: false}, []),
    expand: new FormControl({value: undefined, disabled: false}, []),
  });
  constructor(
    apiConfigService: APIConfigService,
    ngZone: NgZone,
    private service: EspecialService,
  ) {
    super('EspecialCreate', apiConfigService, ngZone);
    this.init();
  }

  submit(value: typeof this.form.value | false = false): Observable<__model.Especial> {
    const result = val => this.service.create(val);
    return this._submit('__model.Especial', result, 'null', value, false );
  }
  listen(value: typeof this.form.value | false = false, submit: boolean = true): Observable<__model.Especial> {
    if (submit) {
      this.submit(value);
    }
    return this._listen(value, submit);
  }


  reset(value?: typeof this.form.value): void {
    this.form.reset();
    super.reset(value, false); 
  }
  patch(value: typeof this.form.value): void {
    this.form.patchValue(value);
  }
}
